import { render, staticRenderFns } from "./DealBannerContent.vue?vue&type=template&id=0171ddd4&scoped=true&"
import script from "./DealBannerContent.vue?vue&type=script&lang=js&"
export * from "./DealBannerContent.vue?vue&type=script&lang=js&"
import style0 from "./DealBannerContent.vue?vue&type=style&index=0&id=0171ddd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171ddd4",
  null
  
)

export default component.exports